var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-input',{class:_vm.classes,attrs:{"value":_vm.value,"type":"range","min":"0","max":"3"},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }